import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { useScrollEdges } from '../../../../../hooks/useScrollEdges';

interface TabsScrollAreaProps {
  children: ReactNode;
  gap?: number | string;
  testId?: string;
}

export function TabsScrollArea({ children, gap = 1, testId }: TabsScrollAreaProps) {
  const { containerRef, startSentinelRef, endSentinelRef, isStartReached, isEndReached } =
    useScrollEdges();

  return (
    <Box sx={{ position: 'relative', width: '100%', minWidth: 0 }}>
      <Box
        ref={containerRef}
        role="tablist"
        test-id={testId}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap,
          overflowX: 'auto',
          py: 0.75,
          my: -0.75,
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        <Box ref={startSentinelRef} aria-hidden sx={{ flex: '0 0 1px', alignSelf: 'stretch' }} />
        {children}
        <Box ref={endSentinelRef} aria-hidden sx={{ flex: '0 0 1px', alignSelf: 'stretch' }} />
      </Box>
      {!isStartReached && (
        <Box
          aria-hidden
          sx={(theme) => ({
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            width: '32px',
            pointerEvents: 'none',
            background: `linear-gradient(to left, transparent, ${theme.palette.custom.layout.workspace})`,
          })}
        />
      )}
      {!isEndReached && (
        <Box
          aria-hidden
          sx={(theme) => ({
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            width: '32px',
            pointerEvents: 'none',
            background: `linear-gradient(to right, transparent, ${theme.palette.custom.layout.workspace})`,
          })}
        />
      )}
    </Box>
  );
}
